import './Profile.css';

export default function Profile() {
  return (
    <div className="profile-page">
      <div className="profile-container">
        <h1>Профиль</h1>
        <div className="profile-content">
          <p>Здесь будет информация о профиле пользователя</p>
        </div>
      </div>
    </div>
  );
}
